import Vue from "vue"
import Vapi from "vuex-rest-api"

const hotels = new Vapi({
  axios: Vue.axios,
  queryParams: true,
  state: {
    hotel: null,
    hotels: [],
    allHotels: [],
    room: null,
    rooms: [],
    allrooms: [],
  },
})

  // hotels
  .get({
    action: "retrieveHotel",
    property: "hotel",
    path: ({ id }) => `/hotels/${id}/`,
  })
  .get({
    action: "listHotels",
    property: "hotels",
    path: "/hotels/",
  })
  .get({
    action: "listAllHotels",
    property: "allHotels",
    path: "/hotels/?no_page=1",
  })
  .post({
    action: "createHotel",
    property: "hotel",
    path: "/hotels/",
  })
  .patch({
    action: "updateHotel",
    property: "hotel",
    path: ({ id }) => `/hotels/${id}/`,
  })
  .delete({
    action: "destroyHotel",
    path: ({ id }) => `/hotels/${id}/`,
  })

  // rooms
  .get({
    action: "retrieveRoom",
    property: "room",
    path: ({ id }) => `/rooms/${id}/`,
  })
  .get({
    action: "listRooms",
    property: "rooms",
    path: "/rooms/",
  })
  .get({
    action: "listAllRooms",
    property: "allRooms",
    path: "/rooms/?no_page=1",
  })
  .post({
    action: "createRoom",
    property: "room",
    path: "/rooms/",
  })
  .patch({
    action: "updateRoom",
    property: "room",
    path: ({ id }) => `/rooms/${id}/`,
  })
  .delete({
    action: "destroyRoom",
    path: ({ id }) => `/rooms/${id}/`,
  })

  // finalize
  .getStore()

export default hotels
